import NP from "../1. Core/NP";
import LibraryBoxBattle from "../10. Battle/Library/LibraryBoxBattle";
import {ServerAPI} from "../1. Core/ServerAPI";

import TopAppBar from "../1. Core/Controls/TopAppBar/TopAppBar";

import AthletesList from "../2. Athletes/AthletesList";
import StatesList from "../2. Athletes/StatesList";
import {getWeights} from "../10. Battle/Util";
import BattleStatGamePad from "../9. DataInput/BattleStatGamePad/BattleStatGamePad";
import BattleStatGamePad2 from "../9. DataInput/BattleStatGamePad/BattleStatGamePad2";
import BattleStatGamePadMMA from "../9. DataInput/BattleStatGamePad/BattleStatGamePadMMA";
import {IBattle, PageMode} from "../10. Battle/types";
import WebhookPanel from "../Admin/WebhookPanel";
import BattleStatGamePadKickboxing from "../9. DataInput/BattleStatGamePad/BattleStatGamePadKickboxing";

let library: LibraryBoxBattle,
	 currentWaiterAppBars: TopAppBar[],
	 wId: any,
	 waiter_cover = NP.createNode(null, 'waiter-cover') as HTMLElement,

	 idTime: any;

const getLibraryBox = function (): LibraryBoxBattle
{
	if (!library)
		library = new LibraryBoxBattle({
			ParentNode: document.body,
			Width: document.body.offsetWidth,
			PageMode: getCurrentUrlMode(),
			OpenedObjectId: getCurrentUrlObjectId()
		});

	return library;
};


function getBarItems()
{
	if (NP.DropPanel.OpenedPanels[0] && NP.DropPanel.OpenedPanels[0].getTopAppBar)
		return [NP.DropPanel.OpenedPanels[0].getTopAppBar()];


	if (NP.getLastOpenedDialog())
		return [NP.getLastOpenedDialog().getTopAppBar()];

	let currentPanel = library && library.getCurrentPanel();

	return [
		currentPanel && (currentPanel as AthletesList).getTopAppBar(),
		currentPanel && currentPanel instanceof StatesList && (currentPanel as StatesList).isDrillDownMode() && (currentPanel as StatesList).getDrillDownPanel().getTopAppBar()];
}


export function showWaiterAnyWay()
{
	currentWaiterAppBars = currentWaiterAppBars ? currentWaiterAppBars.concat(getBarItems()) : getBarItems();
	currentWaiterAppBars.forEach(bar => bar && bar.showWaiter());
	document.body.appendChild(waiter_cover);
}

export function hideWaiter()
{
	if (wId)
	{
		clearTimeout(wId);
		wId = null;
	}
	if (currentWaiterAppBars)
		currentWaiterAppBars.forEach(bar => bar && bar.hideWaiter());
	currentWaiterAppBars = null;

	NP.removeFromParent(waiter_cover);
}


function getCurrentUrlMode()
{
	let pathName = window.location.pathname;
	if (pathName.startsWith("/"))
		pathName = pathName.substring(1, pathName.length)
	return pathName.split("?")[0].split("/")[0];
}

export function getCurrentUrlObjectId(): number | null
{
	let arr = window.location.pathname.split("?")[0].split("/");
	const id = parseInt(arr[arr.length - 1])
	return !isNaN(id) ? id : null;
}

function updateFromUrl()
{
	const pageMode = getCurrentUrlMode();
	const key = getCurrentUrlObjectId();


	NP.processAuthCheckResponse();

	getWeights().then(() =>
	{
		const lib = getLibraryBox();
		if (pageMode)
			lib.setPageMode(pageMode as PageMode, true, key);
		else
			lib.refresh();
		lib.show();
		updateBoxSize();
	});

}

NP.battlehtml = function ()
{
	NP.initHotKeys();

	if (window.location.href.indexOf('webhook') > -1)
	{
		new WebhookPanel({
			ParentNode: document.body,
			Width: document.body.offsetWidth,
		});
		return;
	}

	window.addEventListener('resize', updateBoxSizeTimeout);
	window.addEventListener('beforeunload', () =>
	{
		if (NP.editingBattleId != null)
		{
			ServerAPI.post(`/battle/${NP.editingBattleId}/endEditBattleData`).then(() =>
			{
				NP.editingBattleId = null;
			});
		}
	});

	window.onpopstate = function ()
	{
		if (library)
		{
			NP.closeDialogs();
			NP.checkOldBrowsers();
			updateFromUrl();
		}
	};

	NP.checkOldBrowsers();

	let startWaiter = document.getElementById("startWaiter");
	if (startWaiter)
		document.body.removeChild(startWaiter);


	NP.updateBrowserUrlString = function (isPush: boolean, mode?: string, key?: number)
	{
		let url = '/';
		if (mode != null)
		{
			url += mode;
			if (key != null)
				url += `/${key}`;
		}
		if (window.location.pathname !== url)
		{
			if (isPush)
				window.history.pushState({}, '', url);
			else
				window.history.replaceState({}, '', url);
		}
	};


	NP.processAuthCheckResponse();

	const pageMode = getCurrentUrlMode();

	if (pageMode === PageMode.gamepad || pageMode === PageMode.gamepad2 || pageMode === PageMode.gamepadMMA || pageMode === PageMode.gamepadkb)
	{
		const id = getCurrentUrlObjectId();
		ServerAPI.get(`/battle/${id}`).then((battle: IBattle) =>
		{
			switch (pageMode)
			{
				case PageMode.gamepadMMA:
					ServerAPI.get(`/mma/getBattleNewRound/${battle.Id}`).then((round: number) =>
					{
						(new BattleStatGamePadMMA({
							Battle: battle,
							Round: round,
							IsHideButtonVisible: false
						})).show();
					});
					break;
				case PageMode.gamepadkb:
					ServerAPI.get(`/mma/getBattleNewRound/${battle.Id}`).then((round: number) =>
					{
						(new BattleStatGamePadKickboxing({
							Battle: battle,
							Round: round,
							IsHideButtonVisible: false
						})).show();
					});
					break;
				case PageMode.gamepad2:
					ServerAPI.get(`/box/getBattleNewRound/${battle.Id}`).then((round: number) =>
					{
						(new BattleStatGamePad2({
							Battle: battle,
							Round: round,
							IsHideButtonVisible: false
						})).show();
					});
					break;
				case PageMode.gamepad:
				default:
					ServerAPI.get(`/mma/getBattleNewRound/${battle.Id}`).then((round: number) =>
					{
						(new BattleStatGamePad({
							Battle: battle,
							Round: round,
							IsHideButtonVisible: false
						})).show();
					});
			}
		});
	}
	else
	{
		getWeights().then(() =>
		{
			getLibraryBox().show();
			updateBoxSize();
		});
	}

};

const updateBoxSize = function ()
{
	if (library)
	{
		let width = document.documentElement.clientWidth,
			 height = document.documentElement.clientHeight;

		library.setWidth(width);
		library.setHeight(height - (NP.bannerNode ? 40 : 0));
	}
};

const updateBoxSizeTimeout = function ()
{
	if (idTime)
		clearTimeout(idTime);
	idTime = setTimeout(function ()
	{
		updateBoxSize();
		NP.closeDropPanels();
		idTime = null;
	}, 150);
};

//-------------------------------Waiter bind---------------------------------------------


ServerAPI.EvStartRequest.add(function (sender: any, args: any)
{
	if (args.Show !== false)
		showWaiterAnyWay();
});

ServerAPI.EvEndRequest.add(function ()
{
	if (!ServerAPI.hasActiveRequest())
		hideWaiter();
});

ServerAPI.EvError.add(function (s: any, error: any)
{
	hideWaiter();
	NP.showMessage({Caption: 'Error', Content: error.message})
})
//-------------------------------------Waiter bind end-----------------------------------------------------
